import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import fetchHandler from "@/fetch/fetchHandler";
import { editPermission } from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class DispatchPermissionsModal extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.dispatchPermissionsModal;
    this.state = {
      tableConfig: null,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.modalParams = this.context.store.getState().modalInfo.param;
    this.formConfig = {
      childItems: this.modalParams
        ? [
          {
            type: "input", // 定义表单元素基础类型
            inputType: "text", // 定义表单元素的子类型
            param: {
              // 定义表单元素的参数对象
              name: "name", // 参数名称
              type: "string", // 参数类型，用来做类型检测
            },
            validator: {
              // 自定义校验对象
              vtype: "length", // 校验名称
              min_val: 1, // 规则参数
              max_val: 20,
            },
            labelName: this.internationalization.title1, // '权限名称', // label名称
            required: !0,
            defaultValue: this.modalParams.name || "", // 设置默认值，同设置disabled则不能修改
            placeholder: this.internationalization.placeholder1, // '请输入权限名称'
          },
          // {
          //   type: 'select',
          //   options: [
          //     {
          //       text: '菜单权限',
          //       value: '1'
          //     },
          //     // {
          //     //   text: '菜单分配权限',
          //     //   value: '2'
          //     // },
          //     // {
          //     //   text: '数据城市查询权限',
          //     //   value: '3'
          //     // }
          //   ],
          //   defaultValue:'1',
          //   param: {
          //     name: 'type',
          //     type: 'string'
          //   },
          //   placeholder: '请选择权限类别',
          //   required: !0,
          //   labelName: '权限类别'
          // },
          // {
          //     type: 'select',
          //     options: [
          //         {
          //             text: '是',
          //             value: '1'
          //         },
          //         {
          //             text: '否',
          //             value: '0'
          //         }
          //     ],
          //     defaultValue: this.modalParams.isSecondAdmin
          // ? this.modalParams.isSecondAdmin + '' : '0',
          //     param: {
          //         name: 'isSecondAdmin',
          //         type: 'string'
          //     },
          //     placeholder: '请选择类别',
          //     required: !0,
          //     labelName: '是否二级管理员'
          // },
          {
            type: "transfer",
            transType: "tree",
            titles: [this.internationalization.title2, this.internationalization.title3],
            placeholder: this.internationalization.placeholder2, // '请搜索',
            nofound: this.internationalization.msg1, // '暂无选项',
            itemUnit: this.internationalization.dw1, // '条',
            key: ["treeSource", "treeTarget"],
            param: {
              name: "menuIds",
              type: "array",
            },
          },
          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                text: this.internationalization.btn1, // '确定'
              },
              {
                btnType: "reset",
                text: this.internationalization.btn2, // '清空'
              },
            ],
          },
        ]
        : [
          {
            type: "input", // 定义表单元素基础类型
            inputType: "text", // 定义表单元素的子类型
            param: {
              // 定义表单元素的参数对象
              name: "name", // 参数名称
              type: "string", // 参数类型，用来做类型检测
            },
            validator: {
              // 自定义校验对象
              vtype: "length", // 校验名称
              min_val: 1, // 规则参数
              max_val: 20,
            },
            labelName: this.internationalization.title4, // '权限名称', // label名称
            required: !0,
            defaultValue: this.modalParams.name || "", // 设置默认值，同设置disabled则不能修改
            placeholder: this.internationalization.placeholder3, // '请输入权限名称'
          },
          {
            type: "transfer",
            transType: "tree",
            titles: [this.internationalization.title2, this.internationalization.title3],
            placeholder: this.internationalization.placeholder4, // '请搜索',
            nofound: this.internationalization.msg1, // '暂无选项',
            itemUnit: this.internationalization.dw1, // '条',
            key: ["treeSource", "treeTarget"],
            param: {
              name: "menuIds",
              type: "array",
            },
          },
          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                text: this.internationalization.btn1, // '确定'
              },
              {
                btnType: "reset",
                text: this.internationalization.btn2, // '清空'
              },
            ],
          },
        ],
      layout: "horizontal", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "modal", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
    };
    // this.modalParams.type &&
    // (this.formConfig.childItems[1].defaultValue = this.modalParams.type + '');
  }

  fetchApi = (result) => {
    if (this.formConfig.formTarget === "grid") {
      return;
    }
    if (this.modalParams.permissionId) {
      result.permissionId = this.modalParams.permissionId;
    }
    return fetchHandler(editPermission, result).then((res) => {
      if (res.code === "success") {
        RefreshGrid(this.context.store, "permissionsTable");
      }
    });
  }

  render() {
    return (
      <div>
        <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
      </div>
    );
  }
}

export default injectIntl(DispatchPermissionsModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/permissions/dispatchPermissionsModal.js